import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../../components/inputs/final_form/TextInput";
import { required } from "../../../../util/validators";
import { LoadingButton } from "../../../../components/LoadingButton";
import { Switch } from "../../../../components/inputs/final_form/Switch";

export const QaCategoryForm = ({ handleSubmit, submitting }) => {
  return (
    <>
      <Field component={TextInput} label="Name" name="name" required validate={required} />

      <Field
        className="mb-3"
        component={Switch}
        type="checkbox"
        defaultValue={true}
        required
        validate={required}
        label="Active"
        name="active"
      />

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
